import React from "react";
import Icon from "./common/Icon";
import "./Welcome.css";

const FEATURES = [
  { icon: "fraction", title: "Fractional Node Ownership", text: "Own a fraction of a Smartcore Node from just $10 — no hardware, no setup." },
  { icon: "coins", title: "SCN Token Backed", text: "Every activation mints SCN backed by a real USDT liquidity vault with a live price." },
  { icon: "users", title: "Direct Referral Income", text: "Earn up to 20% on your direct referrals across 9 node tiers." },
  { icon: "node", title: "Matrix Network", text: "A 2×10 forced matrix pays you up to 10 levels deep as your team spills over." },
  { icon: "layers", title: "Generation Levels", text: "10 generation levels reward you for building depth in your sponsor tree." },
  { icon: "shield", title: "2X Growth Ceiling", text: "Transparent on-chain 2X earning ceiling per package — fair and verifiable." },
];

const TOKENOMICS = [
  { icon: "coins", title: "The SCN Fraction Token", text: "SCN (SmartCore Node Fraction Token) is your on-chain share of the node network — minted to you on every package activation." },
  { icon: "shield", title: "USDT Liquidity Vault", text: "Every SCN is backed by a real USDT vault held inside the token contract. No paper promises — the backing is verifiable on-chain." },
  { icon: "gauge", title: "Transparent Live Price", text: "SCN price = vault liquidity ÷ total supply. It moves with real reserves, not hype." },
  { icon: "spark", title: "Built to Appreciate", text: "Part of every purchase and node-appreciation slice adds liquidity. On a sell, SCN is burned and a 10% fee stays in the vault — lifting the price for holders." },
];

const STEPS = [
  { n: 1, title: "Connect Wallet", text: "Use Trust Wallet, MetaMask or any DEX wallet." },
  { n: 2, title: "Activate a Node", text: "Pick a package from $10 to $10,000 in USDT." },
  { n: 3, title: "Earn USDT + SCN", text: "Referral, matrix & generation income paid on-chain." },
  { n: 4, title: "Claim & Grow", text: "Claim SCN anytime and upgrade to higher tiers." },
];

export default function Welcome() {
  return (
    <div className="welcome stack">
      <div className="wel-hero">
        <span className="wel-badge"><Icon name="spark" size={14} /> Decentralized Node Network</span>
        <h1 className="wel-title">Own a Fraction of a <span className="grad-text">Smartcore Node</span></h1>
        <p className="wel-lead">
          Smartcore Node turns expensive blockchain infrastructure into something anyone can own.
          Buy a fraction, power the network, and earn from node appreciation, community income,
          and the SCN token — all settled transparently on-chain.
        </p>
        <div className="wel-stats">
          <div><strong>9</strong><span>Node Tiers</span></div>
          <div><strong>$10+</strong><span>Entry</span></div>
          <div><strong>2X</strong><span>Ceiling</span></div>
          <div><strong>10</strong><span>Levels</span></div>
        </div>
      </div>

      <div className="card">
        <div className="section-title">Why Smartcore Node</div>
        <div className="wel-grid">
          {FEATURES.map((f) => (
            <div className="wel-feature" key={f.title}>
              <span className="wel-fico"><Icon name={f.icon} size={20} /></span>
              <div className="wel-ftitle">{f.title}</div>
              <div className="wel-ftext muted">{f.text}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="card">
        <div className="section-title">SCN Token &amp; Liquidity</div>
        <div className="wel-tok">
          {TOKENOMICS.map((t) => (
            <div className="wel-tok-row" key={t.title}>
              <span className="wel-tok-ico"><Icon name={t.icon} size={18} /></span>
              <div>
                <div className="wel-ftitle">{t.title}</div>
                <div className="wel-ftext muted">{t.text}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="wel-liq">
          <div className="wel-liq-item"><span className="muted">Buy</span><strong>USDT in → SCN minted</strong></div>
          <div className="wel-liq-arrow">⇅</div>
          <div className="wel-liq-item"><span className="muted">Sell</span><strong>SCN burned → USDT out</strong></div>
        </div>
      </div>

      <div className="card">
        <div className="section-title">How It Works</div>
        <div className="wel-steps">
          {STEPS.map((s) => (
            <div className="wel-step" key={s.n}>
              <span className="wel-snum">{s.n}</span>
              <div>
                <div className="wel-stitle">{s.title}</div>
                <div className="muted" style={{ fontSize: 13 }}>{s.text}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
